module.exports = __webpack_public_path__ + "8ec7e03775a36959dfe6a06098d60181.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/19-Betsolutions-Drunk-Santa.png
// module id = 1741
// module chunks = 2